export const setLocalization = (state, lang) => {
  state.language = lang
}
